import React, { FC } from 'react';

import { PRIMARY_BLUE } from 'constants/colours';

interface AIGenerateIconProps {
  color?: string;
  size?: number;
}

const AIGenerateIcon: FC<React.PropsWithChildren<AIGenerateIconProps>> = ({
  color = PRIMARY_BLUE,
  size = 16
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.3335 1.33334C6.64257 1.33334 7.03956 1.53938 7.10831 2.00527L7.15264 2.30569C7.41657 4.09421 8.82852 5.5519 10.7051 5.90515C11.543 6.06287 11.543 7.27049 10.7051 7.42821C8.82852 7.78145 7.41657 9.23914 7.15264 11.0277L7.10831 11.3281C7.03956 11.794 6.64257 12 6.33349 12C6.02442 12 5.62743 11.794 5.55868 11.3281L5.51435 11.0277C5.25042 9.23914 3.83847 7.78145 1.9619 7.42821C1.12403 7.27049 1.12402 6.06287 1.9619 5.90515C3.83847 5.5519 5.25042 4.09421 5.51435 2.30569L5.55868 2.00527C5.62743 1.53937 6.02442 1.33334 6.3335 1.33334Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0002 9.33334C12.165 9.33334 12.3767 9.43636 12.4134 9.66931L12.437 9.81952C12.5778 10.7138 13.3308 11.4426 14.3317 11.6192C14.7785 11.6981 14.7785 12.3019 14.3317 12.3808C13.3308 12.5574 12.5778 13.2862 12.437 14.1805L12.4134 14.3307C12.3767 14.5637 12.165 14.6667 12.0002 14.6667C11.8353 14.6667 11.6236 14.5637 11.5869 14.3307L11.5633 14.1805C11.4225 13.2862 10.6695 12.5574 9.66865 12.3808C9.22178 12.3019 9.22178 11.6981 9.66865 11.6192C10.6695 11.4426 11.4225 10.7138 11.5633 9.81952L11.5869 9.66931C11.6236 9.43636 11.8353 9.33334 12.0002 9.33334Z"
        fill={color}
      />
    </svg>
  );
};

export default AIGenerateIcon;
